import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { ProductListPage, productListSortEnum } from "@/modules/product";
import { requireAuthAndPermission } from "@/utils";

const productTabEnum = z.enum(["product", "draft"]);

const productListSearchSchema = z.object({
  tab: fallback(productTabEnum, "product").default("product"),
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1),
  sort: fallback(productListSortEnum, "newest").default("newest"),
  draft_q: fallback(z.string(), "").default(""),
  draft_page: fallback(z.number(), 1).default(1),
  draft_sort: fallback(productListSortEnum, "newest").default("newest")
});

export const Route = createFileRoute("/products/list/")({
  validateSearch: zodValidator(productListSearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Products"
        description="Manage and list your products on the LAMPU Marketplace."
      />
      <ProductListPage />
    </>
  )
});
